import { useMemo } from "react";
import { IItem } from "@/redux/profile/history/types";
import { groupByDate, getFinishTime } from "../utils/dateUtils";

export const useHistoryData = (items: IItem[]) => {
  const { upcoming, completed } = useMemo(() => {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    const upcomingArr: IItem[] = [];
    const completedArr: IItem[] = [];

    items.forEach(item => {
      const finishTime = getFinishTime(item);
      
      if (!finishTime) {
        completedArr.push(item);
        return;
      }

      if (finishTime > now) {
        upcomingArr.push(item);
      } else if (finishTime <= now && finishTime >= sixMonthsAgo) {
        completedArr.push(item);
      }
    });

    const upcomingGrouped = groupByDate(upcomingArr);
    const completedGrouped = groupByDate(completedArr);

    return {
      upcoming: upcomingGrouped,
      completed: completedGrouped
    };
  }, [items]);

  return { upcoming, completed };
};
